import { useEffect, useState } from 'react';
import {
  Select,
  SelectItem,
  SelectPosition,
  SelectSizesMD,
} from '@picsart/design-system/components/Select';
import { useSearchParams } from 'react-router-dom';
import useQueryParams from '../hooks/useQueryParam';

import { FilterSelectProps } from '../types';
import useStyles from './styles';

const FilterSelect = ({ filterData }: FilterSelectProps) => {
  const styles = useStyles();
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const { paramList } = useQueryParams();
  const isQueryParam = [...searchParams.entries()].length > 0;
  useEffect(() => {
    const commonValue = isQueryParam
      ? filterData.options.find(value => paramList.includes(value)) || null
      : filterData.name;
    setSelectedValue(commonValue);
  }, [filterData.name, filterData.options, isQueryParam, paramList]);

  const handleChange = (value: string) => {
    const param = JSON.parse(value);

    searchParams.set(param.filterName, param.value.toLowerCase());

    if (searchParams.get('q')) {
      searchParams.set('q', searchParams.get('q')!);
    }

    setSearchParams(searchParams);
  };

  return (
    <Select
      defaultPosition={SelectPosition.Bottom}
      label={filterData.name}
      className={styles.filterSelect}
      size={SelectSizesMD}
      value={selectedValue}
      onChange={handleChange}
      zIndex={9}
      count={5}
    >
      {filterData.options.map(option => {
        const queryConstruct = JSON.stringify({
          filterName: filterData.queryName,
          value: option,
        });
        const isActive = selectedValue === option;

        return (
          <SelectItem
            aria-label={`${filterData.queryName} ${option}`}
            isActive={isActive}
            value={queryConstruct}
            key={option}
          >
            {option}
          </SelectItem>
        );
      })}
    </Select>
  );
};

export default FilterSelect;
